import { render, staticRenderFns } from "./ClientProspectList.vue?vue&type=template&id=f8778784"
import script from "./ClientProspectList.vue?vue&type=script&lang=js"
export * from "./ClientProspectList.vue?vue&type=script&lang=js"
import style0 from "./ClientProspectList.vue?vue&type=style&index=0&id=f8778784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports